<template>
  <Modal v-model="passThroughValue" :title="$t(`${translationKey}.headline`)" :customerConfig="customerConfig" :showCloseButton="false" class="honeywell-modal">
    <template #close-button>
      <button
        type="button"
        class="honeywell-close"
        aria-label="close dialog"
        @click="closeModal"
        @keydown.enter="closeModal"
        @keydown.space="closeModal"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.65 12.075L12.075 13.65C11.725 13.825 11.55 14 11.2 14C10.85 14 10.675 13.825 10.325 13.65L6.825 10.15L3.325 13.65C3.325 13.825 2.975 14 2.8 14C2.45 14 2.1 13.825 1.925 13.65L0.35 12.075C0.175 11.725 0 11.55 0 11.2C0 10.85 0.175 10.675 0.35 10.325L3.85 6.825L0.35 3.325C0.175 3.325 0 2.975 0 2.8C0 2.45 0.175 2.275 0.35 1.925L1.925 0.35C2.1 0.175 2.45 0 2.8 0C2.975 0 3.325 0.175 3.5 0.35L7 3.85L10.5 0.35C10.675 0.175 10.85 0 11.2 0C11.55 0 11.725 0.175 12.075 0.35L13.65 1.925C13.825 2.1 14 2.45 14 2.8C14 2.975 13.825 3.325 13.65 3.5L10.15 7L13.65 10.5C13.825 10.675 14 10.85 14 11.2C14 11.55 13.825 11.725 13.65 12.075Z" fill="#AFAFAF"/>
        </svg>
      </button>
    </template>
    <div tabindex="-1" :style="{ '--provider-color': theme.primaryColor }">
      <p class="introduction-text">
        {{ $t(`${translationKey}.introduction`) }}
      </p>
      <p class="introduction-text">
        {{ $t(`${translationKey}.introduction2`) }}
      </p>
      <div class="row modal-tiles">
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div class="modal-tiles--content">
            <div class="modal-tiles--tile--icon">
              <img class="icon-main" id="device" src="@/assets/icons/mobile.svg" alt="">
            </div>
            <p class="modal-tiles--tile--header" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step1Header`) }}
            </p>
            <p class="modal-tiles--tile--headline" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step1Headline`) }}
            </p>
            <p class="modal-tiles--tile--desc">
              {{ $t(`${translationKey}.step1`) }}
            </p>
          </div>
        </div>
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div class="modal-tiles--content">
            <div class="modal-tiles--tile--icon">
              <img class="icon-main" src="@/assets/icons/house.svg" alt="">
            </div>
            <p class="modal-tiles--tile--header" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step2Header`) }}
            </p>
            <p class="modal-tiles--tile--headline" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step2Headline`) }}
            </p>
            <p class="modal-tiles--tile--desc">
              {{ $t(`${translationKey}.step2`) }}
            </p>
          </div>
        </div>
        <div class="col-md col-sm-12 modal-tiles--tile text-center">
          <div class="modal-tiles--content">
            <div class="modal-tiles--tile--icon">
              <img class="icon-main" id="file" src="@/assets/icons/file.svg" alt="">
            </div>
            <p class="modal-tiles--tile--header" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step3Header`) }}
            </p>
            <p class="modal-tiles--tile--headline" v-bind:style="{ color: theme.primaryColor }">
              {{ $t(`${translationKey}.step3Headline`) }}
            </p>
            <p class="modal-tiles--tile--desc">
              {{ $t(`${translationKey}.step3`) }}
            </p>
          </div>
        </div>
      </div>
      <div class="row completion-instructions">
        <div class="col">
          <p>
            {{ $t(`${translationKey}.ending`) }}
          </p>
          <button
            v-bind:style="{ backgroundColor: theme.primaryColor }"
            v-on:click="saveAndRedirect();"
          >
            {{ $t(`${translationKey}.button`) }}
          </button>
        </div>
      </div>
      <p class="text-center">
        {{ $t(`${translationKey}.supportEmail`) }}
        <a
          v-bind:style="{ color: theme.primaryColor }"
          v-bind:href="'mailto:' + supportEmail"
        >
          {{ supportEmail }}
        </a>
      </p>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'honeywell-modal',
  components: { Modal },
  inject: {
    theme: { default: defaultTheme },
  },
  props: {
    value: Boolean,
    app: String,
    customerConfig: Object,
  },
  data() {
    return {
      supportEmail: 'support@virtual-peaker.com',
      passThroughValue: false,
    };
  },
  computed: {
    translationKey() {
      return this.app === 'honeywellFirstAlert' ? 'modalHoneywellFirstAlert' : 'modalHoneywellResideo';
    },
  },
  watch: {
    value() {
      this.passThroughValue = this.value;
    },
    passThroughValue(val) {
      this.$emit('input', val);
      if (val) {
        this.$nextTick(() => {
          const wrapper = this.$el.querySelector('.modal-wrapper');
          if (wrapper) wrapper.scrollTop = 0;
        });
      }
    },
  },
  mounted() {
    this.supportEmail = this.customerConfig?.supportEmail || 'support@virtual-peaker.com';
    this.passThroughValue = this.value;
  },
  methods: {
    closeModal() {
      this.passThroughValue = false;
    },
    saveAndRedirect() {
      this.$router.push({ name: 'success', params: { type: 'honeywell' } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins.scss';

.honeywell-modal ::v-deep {
  @include Mobile-Only {
    p {
      margin: 9px 16px;
    }
  }

  .modal-content {
    border: none;

    @include Mobile-Only {
      height: auto;
      min-height: 100%;
    }
  }

  .modal-wrapper {
    vertical-align: middle;

    @include Mobile-Only {
      display: block;
      height: 100%;
      overflow-y: auto;
      padding: 0 32px 50px;
    }
  }

  .modal-body {
    p {
      margin: unset;
      margin-top: 24px;

      @include Mobile-Only {
        margin-bottom: 24px;
      }

      &.introduction-text {
        margin: 0 0 24px 0;

        @include Mobile-Only {
          margin: 24px 0;
        }
      }
    }
    @include Mobile-Only {
      position: static;
      transform: none;
      top: unset;
      padding-top: 0;
    }
    @include Not-Mobile {
      margin: 32px 50px;
    }
  }

  .introduction-text {
    margin: 0 0 24px 0;
  }

  .modal-dialog {
    @include Tablet {
      height: auto;
      max-width: 771px;
    }
  }

  .modal-header {
    padding: 20px 50px;
    align-items: center;

    @include Mobile-Only {
      padding: 4rem 0 2rem;
    }

    @include Not-Mobile {
      border-radius: 10px 10px 0 0;
      background: #FFF;
      box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.08);
    }
  }

  #modal-title {
    color: var(--provider-color, #016699);
    display: block;
    padding: 0;
    margin-bottom: 0px;

    @include Mobile-Only {
      z-index: 10;
    }
  }

  #modal-title-mobile {
    display: none;
  }

  .honeywell-close {
    z-index: 10;
    background: none;
    border: none;
    padding: 0 0 0 24px;
    cursor: pointer;
    min-width: unset;
    margin: 0;

    &:hover {
      opacity: 0.7;
    }
  }

  .row.completion-instructions {
    text-align: center;
    width: auto;

    @include Mobile-Only {
      padding: 0 24px;
    }

    p {
      margin: 0 0 24px 0;

      @media (max-width: 767px) {
        margin: 24px 0;
      }
    }

    .col {
      button {
        margin: 0;
        min-width: 160px;
        max-height: 40px;
        border-radius: 4px;
        border: 2px solid var(--provider-color, #016699);
        background: var(--provider-color, #016699);
      }
    }
  }

  .row.modal-tiles {
    gap: 16px;
    width: auto;
    margin: unset;
    margin: 24px 0;

    @media (min-width: 576px) and (max-width: 767px) {
      margin-right: auto;
      margin-left: auto;
    }

    @media (max-width: 767px) {
      margin-bottom: 0;
    }

    div.modal-tiles--tile {
      padding: 0px 0px;
      border-radius: 8px;
      border: 1px solid #DBDBDB;
      background: #FFF;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10);

      @include Not-Mobile {
        margin-left: auto;
        margin-right: auto;
      }

      @include Tablet {
        max-height: 258px;
        max-width: 213px;
      }

      @media (max-width: 767px) {
        height: 100%;
      }

      p {
        text-align: center;
        font-style: normal;

        &.modal-tiles--tile--header,
        &.modal-tiles--tile--headline {
          margin: unset;
          font-size: 14px;
          font-weight: 700;
          line-height: 21px;
        }

        &.modal-tiles--tile--header {
          margin-top: 10px;
        }

        &.modal-tiles--tile--desc {
          margin: unset;
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
          color: #4F4F4F;
        }
      }
      .modal-tiles--tile--icon {
        height: unset;
        position: unset;
      }
      .modal-tiles--tile--icon .icon-main {
        height: 43px;
        color: #A6B1C3;
      }
    }
  }

  .modal-tiles--content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 42px 20px;
  }
}
</style>
